import { formatTemplate } from './format-template';
import { hasAllTemplateParams } from './has-all-template-params';
/**
 * Formats given, middle, and family names as a string.
 *
 * @hidden
 * @param personName The given, middle, and family names.
 * @param options The template format options to be used.
 * @returns The formatted string.
 */
export const formatPersonName = (personName, options) => {
    const params = Object.assign(Object.assign({}, personName), { givenInitial: personName.givenName ? personName.givenName.slice(0, 1) : undefined, middleInitial: personName.middleName ? personName.middleName.slice(0, 1) : undefined, familyInitial: personName.familyName ? personName.familyName.slice(0, 1) : undefined });
    const template = options.personName.formats.find(format => hasAllTemplateParams(format, params));
    if (!template) {
        return undefined;
    }
    return formatTemplate(template, params, options);
};
//# sourceMappingURL=format-person-name.js.map